export const SITE_NAME = "حساسات كفرات الرياض";
export const SITE_NAME_EN = "Riyadh Tire Sensors";
export const PHONE = "+966540377559";
export const PHONE_LINK = "tel:+966540377559";
export const WA_NUMBER = "966540377559";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const WA_DEFAULT_MSG =
  "السلام عليكم، أرغب في الاستفسار عن حساسات الكفرات.";

const WM = "https://commons.wikimedia.org/wiki/Special:FilePath";

export const IMAGES = {
  heroRim:
    "https://images.pexels.com/photos/27776503/pexels-photo-27776503.jpeg?auto=compress&cs=tinysrgb&w=1200",
  amgRim:
    "https://images.unsplash.com/photo-1616788902258-138db56fe7e5?auto=format&fit=crop&w=900&q=80",
  blueWheel:
    "https://images.pexels.com/photos/9735323/pexels-photo-9735323.jpeg?auto=compress&cs=tinysrgb&w=900",
  workshop:
    "https://images.unsplash.com/photo-1727893119356-1702fe921cf9?auto=format&fit=crop&w=900&q=80",
  technician:
    "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?auto=format&fit=crop&w=900&q=80",
  dashboard:
    "https://images.unsplash.com/photo-1610913721979-b20ede600e63?auto=format&fit=crop&w=900&q=80",
  speedometer:
    "https://images.unsplash.com/photo-1611760357505-922600d8ffa6?auto=format&fit=crop&w=900&q=80",
  sensorOem: `${WM}/TPMS_front_side.jpg?width=900`,
  sensorAftermarket: `${WM}/DTPMS_direct_Tire-pressure_monitoring_system_sensors.jpg?width=900`,
  sensorProgrammable: `${WM}/Tire_pressure_sensors.jpg?width=900`,
  valveCore: `${WM}/Tire_Valve_Stem.jpg?width=900`,
  diagTool: `${WM}/OBD_Auto_Scanner_connecting_to_the_ECU.JPG?width=900`,
  sensorInTire: `${WM}/Tire_pressure_sensor_in_tire.jpg?width=900`,
  sensorRemoval: `${WM}/DamagedTPMSSensorBeingRemoved.jpg?width=900`,
};

export const BRANDS = [
  "تويوتا", "لكزس", "نيسان", "هيونداي", "كيا", "فورد", "شفروليه", "جي إم سي",
  "هوندا", "مازدا", "مرسيدس بنز", "بي إم دبليو", "أودي", "فولكس فاجن",
  "جيلي", "شانجان", "إم جي", "جريت وول",
];

export const SERVICES = [
  {
    id: "sale",
    title: "بيع حساسات ضغط الكفرات TPMS",
    desc: "استفسر عن الحساس المناسب لسيارتك حسب الموديل وسنة الصنع.",
    icon: "Gauge",
  },
  {
    id: "programming",
    title: "برمجة حساسات الكفرات",
    desc: "المساعدة في برمجة الحساسات المتوافقة مع نظام السيارة.",
    icon: "Cpu",
  },
  {
    id: "replacement",
    title: "استبدال حساسات الكفرات",
    desc: "استبدال الحساسات التالفة واختيار البديل المناسب حسب التوافق.",
    icon: "RefreshCcw",
  },
  {
    id: "inspection",
    title: "فحص حساسات الكفرات",
    desc: "المساعدة في تحديد أسباب تعطل الحساس أو ظهور تحذير ضغط الإطارات.",
    icon: "ScanSearch",
  },
  {
    id: "selection",
    title: "اختيار الحساس المناسب",
    desc: "تحديد نوع الحساس المطلوب وفق بيانات السيارة ونظام مراقبة الضغط.",
    icon: "Crosshair",
  },
];

export const SERVICE_TYPES = SERVICES.map((s) => s.title);

export const CATEGORIES = [
  { id: "all", label: "الكل" },
  { id: "oem", label: "حساسات أصلية" },
  { id: "aftermarket", label: "حساسات بديلة" },
  { id: "programmable", label: "حساسات قابلة للبرمجة" },
  { id: "valves", label: "صمامات الحساسات" },
  { id: "tools", label: "أجهزة برمجة وفحص" },
];

export const buildOrderMessage = ({ name, make, model, year, service, details }) =>
  [
    "السلام عليكم، أرغب في الاستفسار عن حساسات الكفرات.",
    "",
    `اسم العميل: ${name}`,
    `الشركة المصنعة: ${make}`,
    `الموديل: ${model}`,
    `سنة الصنع: ${year}`,
    `الخدمة المطلوبة: ${service}`,
    `تفاصيل إضافية: ${details || "لا يوجد"}`,
    "",
    "أرجو إفادتي بالحساس المناسب والتكلفة.",
  ].join("\n");
